import * as React from 'react';
import { Link } from 'react-router-dom';

export interface Props {
  title: string;
  href: string | undefined;
  className?: string;
  children?: React.ReactNode;
}

export default function BreadcrumbItem(props: Props) {
  const { title, href } = props;

  // AtlaskitBreadcrumbItem passes content as children
  const content = props.children ? props.children : title;

  // AtlaskitBreadcrumbItem passes default href as '#'
  return href && href !== '#' ? (
    // AtlasKit passes className as props.className, needed for it's styles to work
    <Link to={href} className={props.className}>
      {content}
    </Link>
  ) : (
    <a className="no-href">{content}</a>
  );
}
